__turbopack_context__.v({
  "container": "TG4VWa_container",
  "text": "TG4VWa_text",
});
